/* Maximum walk-up iterations when trying to match
 * fields located outside of a form candidate */
export const MAX_FORM_FIELD_WALK_UP = 3;

/* Maximum walk-up depth when trying to match
 * headings pertaining to a form candidate */
export const MAX_FORM_HEADING_WALK_UP = 3;

export const MAX_HEADING_HORIZONTAL_DIST = 75;
export const MAX_HEADING_VERTICAL_DIST = 150;

/* When clustering input fields we need to decide
 * when to merge clusters : this distance is the
 * maximum distance from center-to-center for the
 * nodes in two clusters needed for a merge */
export const MAX_CLUSTER_SPLIT_DISTANCE = 400;

/* Number of walk-up iterations when checking the
 * visibility of an element against its parent's */
export const MAX_VISIBILITY_WALK_UP = 1;

/* When looking for submit buttons that are not of
 * input[type="submit"] - we want to keep only buttons
 * of a relevant size */
export const MIN_AREA_SUBMIT_BTN = 3_000;

/* ignore fields which are incorrectly hidden and have
 * an offset height smaller than this value */
export const MIN_FIELD_HEIGHT = 15;
export const MIN_FIELD_WIDTH = 30;

/* above this heuristic value - we should not even consider
 * a form candidate */
export const MAX_INPUTS_PER_FORM = 50; /* user editable fields */
export const MAX_FIELDS_PER_FORM = 100; /* including `[type="hidden"]` */

export const MAX_HIDDEN_FIELD_VALUE_LENGTH = 320; /* max email length as a heuristic */
export const HIDDEN_FIELD_IGNORE_VALUES = ["0", "1", "true", "false"];

/* Common input pattern validation found on OTP fields */
export const OTP_PATTERNS: string[] = ["[0-9]{6}", "[0-9]{1}", "[0-9]*", "d{6}", "d{6}*", "d{1}", "/d{6}", "/d{6}*", "/d{1}"];

export const VALID_INPUT_TYPES = ["text", "email", "number", "tel", "password", "hidden", "search"];
